export default "__VITE_ASSET__0977cb3f__"